import type { GetServerSidePropsContext } from 'next';

import { getCookies } from '~/utils/cookie';
import { ENV } from '~/utils/env';
import { isClient } from '~/utils/ssr';

const getTokenbyCookie = (cookies: Record<string, unknown>) => {
  switch (ENV) {
    case 'prod':
      return cookies.snowdon_production_jwt;
    case 'stg':
      return cookies.snowdon_production_jwt;
    // return cookies.snowdon_staging_jwt;
    case 'dev':
      return cookies.snowdon_dev_jwt;
    default:
      return cookies.snowdon_dev_jwt;
  }
};

export const getSnowdonJwt = (context?: GetServerSidePropsContext) => {
  const cookies = getCookies(context);
  let jwt = getTokenbyCookie(cookies);

  if (isClient() && !jwt) {
    const token = window.localStorage.getItem('token');
    if (token) {
      jwt = token;
    }
  }

  return jwt as string;
};
